import { type RefObject, useEffect, useRef, useState } from 'react'

interface UseResultItemLabelReducer {
  counterRef: RefObject<HTMLDivElement | null>
  hiddenLabelsCounter: number
  ref: RefObject<HTMLDivElement | null>
}

// if offsetTop > BASE_OFFSET it means the item is wrapped and hidden
const BASE_OFFSET = 2
const ITEMS_GAP = 12

export const useResultItemLabelReducer = (): UseResultItemLabelReducer => {
  const ref = useRef<HTMLDivElement | null>(null)
  const counterRef = useRef<HTMLDivElement | null>(null)
  const [hiddenLabelsCounter, setHiddenLabelsCounter] = useState<number>(0)

  useEffect(() => {
    const checkWidth = (): void => {
      let hiddenLabelTmpCounter = 0
      setHiddenLabelsCounter(hiddenLabelTmpCounter)
      if (!ref.current) {
        return
      }

      const referenceOffset =
        ref.current.parentElement?.getBoundingClientRect().x ?? 0
      let counterLeft = 0

      for (const item of ref.current.children) {
        if (item instanceof HTMLElement) {
          if (item.offsetTop > BASE_OFFSET) {
            hiddenLabelTmpCounter += 1
            setHiddenLabelsCounter(hiddenLabelTmpCounter)
          } else {
            counterLeft =
              item.getBoundingClientRect().right + ITEMS_GAP - referenceOffset
          }
        }
      }

      if (counterRef.current instanceof HTMLElement) {
        counterRef.current.style.left = `${counterLeft}px`
      }
    }

    checkWidth()

    window.addEventListener('resize', checkWidth)

    return (): void => {
      window.removeEventListener('resize', checkWidth)
    }
  }, [])

  return { counterRef, hiddenLabelsCounter, ref }
}
